module.exports = __webpack_public_path__ + "static/img/dynamica.566a7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamica.png
// module id = 1lgn
// module chunks = 45